import { render, staticRenderFns } from "./ContractPic.vue?vue&type=template&id=2c090d33&"
import script from "./ContractPic.vue?vue&type=script&lang=js&"
export * from "./ContractPic.vue?vue&type=script&lang=js&"
import style0 from "./ContractPic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c090d33')) {
      api.createRecord('2c090d33', component.options)
    } else {
      api.reload('2c090d33', component.options)
    }
    module.hot.accept("./ContractPic.vue?vue&type=template&id=2c090d33&", function () {
      api.rerender('2c090d33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/liangshu/ContractPic.vue"
export default component.exports